import React, { useEffect } from "react";
import styled from "styled-components";
import { ImageGallery } from "react-image-grid-gallery";
import gebaeudeImage from "../../assets/images/verkostung/4688 Entdecken.jpg";
import teamImage from "../../assets/images/verkostung/5083 Entdecken.jpg";
import gastgeberinImage from "../../assets/images/verkostung/5139 Entdecken.jpg";
import verkostungsraumImage from "../../assets/images/verkostung/5159 Entdecken.jpg";
import kaesepflegeImage from "../../assets/images/verkostung/5633 Entdecken.jpg";
import kaeselaibeImage from "../../assets/images/verkostung/5769 Entdecken.jpg";
import reifelagerImage from "../../assets/images/verkostung/5868 Entdecken.jpg";
import HeadingOne from "../../components/HeadingOne";
import HeadingTwo from "../../components/HeadingTwo";
import colors from "../../constants/colors";
import constants from "../../constants/constants";

const TastingData = [
  {
    heading: "Käse trifft Reife",
    description:
      "Euer eigener Teller mit ausgewählten Weich- und Hartkäsen, natürlich aus unserem Reifelager. Dazu ein Getränk der Brauerei Egg. Neben dem Verkosten der einzelnen Käsesorten, erzählen wir euch, was es für die gute Reife wirklich braucht.",
    duration: "ca. 50 Min.",
    group: "ab 8 Personen",
    price: "€ 24 pro Person",
  },
  {
    heading: "Käse trifft Bier",
    description:
      "Euer eigener Teller mit Weich- und Hartkäsen aus unserem Reifelager und Feinkostraritäten aus der Region – dazu die passende Bierbegleitung der Brauerei Egg. Neben dem Verkosten der verschiedenen Bier- und Käsesorten, bekommt ihr einen umfassenden Einblick in unser Schaffen und Tun.",
    duration: "ca. 75 Min.",
    group: "ab 8 Personen",
    price: "€ 35 pro Person",
  },
  {
    heading: "Käse trifft Feinkost",
    description:
      "Käse und Feinkost, auf einer großen Platte angerichtet – perfekt zum Teilen, Genießen und gemütlichen Zusammensein. Dazu ein Getränk der Brauerei Egg.",
    duration: "ca. 50 Min.",
    group: "ab 8 Personen",
    price: "€ 18 pro Person",
  },
];

const IMAGES = [
  { id: 1, src: reifelagerImage, alt: "Das Ziegelgewölbe unseres Reifelagers" },
  { id: 2, src: kaesepflegeImage, alt: "Käsepflege im Reifelager" },
  { id: 3, src: verkostungsraumImage, alt: "Der Verkostungsraum" },
  { id: 4, src: kaeselaibeImage, alt: "Käselaibe auf den Holzbrettern im Reifelager" },
  { id: 5, src: teamImage, alt: "Unsere Gastgeber im Verkostungsraum" },
  { id: 6, src: gastgeberinImage, alt: "Gastgeberin im Verkostungsraum" },
  { id: 7, src: gebaeudeImage, alt: "Das Reifelager in Egg im Abendlicht" },
];

// Replaces the library's masonry columns; the grid itself lives in GalleryWrapper
const galleryStyles = {
  galleryContainerStyle: {},
  imageBtnStyle: {
    display: "block",
    width: "100%",
    border: "none",
    background: "none",
    margin: 0,
    padding: 0,
    cursor: "pointer",
  },
  imageContainerStyle: { margin: 0, position: "relative", overflow: "hidden" },
  imageStyle: {
    display: "block",
    width: "100%",
    aspectRatio: "3 / 2",
    objectFit: "cover",
    backgroundColor: "#D9D5C8",
  },
};

const DiscoverPage = () => {
  useEffect(() => {
    document.title = "Verkostung";
  }, []);

  return (
    <Wrapper>
      <HeadingOne title="Drei Wege, gut gereiften Käse zu erleben." />

      <Content>
        <Columns>
          {TastingData.map((item) => (
            <Article key={item.heading}>
              <HeadingTwo title={item.heading} color="DEFAULT" />
              <Description>{item.description}</Description>
              <Details>
                <dt>Dauer</dt>
                <dd>{item.duration}</dd>
                <dt>Gruppe</dt>
                <dd>{item.group}</dd>
                <Price>{item.price}</Price>
              </Details>
            </Article>
          ))}
        </Columns>

        <Booking aria-label="Reservieren & genießen">
          <HeadingTwo title="Reservieren & genießen" color="DEFAULT" />
          <BookingInfo>
            <Description>
              Schickt uns euren Wunschtermin mit Datum und Uhrzeit per E-Mail an{" "}
              <Link href="mailto:info@gutgereift.at">info@gutgereift.at</Link>{" "}
              oder per WhatsApp an{" "}
              <Link href="https://wa.me/436644142827">+43 664 414 28 27</Link>.
            </Description>
            <Address>
              <AddressLabel>Adresse Reifelager</AddressLabel>
              <span>Tuppen 487, 6863 Egg</span>
            </Address>
          </BookingInfo>
        </Booking>
      </Content>

      <Closing>Guter Käse. Gute Reife. Gute Zeit.</Closing>

      <Gallery>
        <HeadingTwo title="Bildergalerie" color="DEFAULT" />
        <GalleryWrapper>
          <ImageGallery
            imagesInfoArray={IMAGES}
            gapSize={15}
            customStyles={galleryStyles}
          />
        </GalleryWrapper>
      </Gallery>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 91%;
  max-width: 1600px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 40px 0 96px;
  font-family: "Montserrat", sans-serif;
  color: ${colors.MineshaftGreyText};

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    width: auto;
    padding: 24px 16px 48px;
  }
`;

// Three narrow columns like "Wer wir sind", booking info below
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  margin-top: 64px;

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    margin-top: 40px;
  }
`;

const Columns = styled.div`
  display: flex;
  gap: 56px 3.01vw;
  max-width: 100%;

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    flex-direction: column;
    gap: 40px;
  }
`;

const Article = styled.article`
  flex: 0 1 300px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    flex: none;
  }
`;

const Description = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 300;
  line-height: 1.6;
  flex: 1;
`;

const Details = styled.dl`
  margin: 0;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 14px;
  font-size: 14px;

  dt {
    font-weight: 300;
  }

  dd {
    margin: 0;
    font-weight: 500;
  }
`;

const Price = styled.dd`
  grid-column: 2;

  // Beats the generic dd rule in Details
  && {
    font-weight: 600;
    color: #675926;
  }
`;

const Gallery = styled.section`
  margin-top: 64px;

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    margin-top: 40px;
  }
`;

// Desktop: three large images on top, four below. Mobile: first image full width, then pairs.
const GalleryWrapper = styled.div`
  margin-top: 32px;

  & > div {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 15px;
  }

  & > div > button {
    grid-column: span 3;
  }

  & > div > button:nth-child(-n + 3) {
    grid-column: span 4;
  }

  & img {
    transition: transform 0.6s ease;
  }

  & button:hover img,
  & button:focus-visible img {
    transform: scale(1.04);
  }

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    & > div {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }

    & > div > button,
    & > div > button:nth-child(-n + 3) {
      grid-column: span 1;
    }

    & > div > button:first-child {
      grid-column: span 2;
    }
  }
`;

const Booking = styled.section`
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const BookingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  font-size: 15px;
`;

const Link = styled.a`
  font-weight: 500;
  color: ${colors.CongressBlueHeader};
  white-space: nowrap;

  &:hover {
    color: #675926;
  }
`;

const Address = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  line-height: 1.6;
`;

const AddressLabel = styled.span`
  font-weight: 600;
`;

const Closing = styled.p`
  margin: 64px 0 0;
  text-align: left;
  font-family: "Sorts Mill Goudy", serif;
  font-style: italic;
  font-size: clamp(24px, 3vw, 32px);
  color: #675926;

  @media (max-width: ${constants.nexusPortraitWidth}px) {
    margin-top: 40px;
  }
`;

export default DiscoverPage;
